import { ContactPerson } from './ContactPerson'

export enum ProductionDistance {
  NAH = 'NAH',
  FERN = 'FERN',
}

export type OrganizationUnit = {
  uuid: string
  name?: string
  employeeAmount?: number
  productionDistance?: ProductionDistance
  contactPersonList?: ContactPerson[]
}
